<template>
  <div class="container history-block">
    <b-tabs content-class="history-tab-content">


      <b-tab title="Презентации" active>
        <p class="titleMain">История проведенных презентаций</p>
        <p v-if="presentationsList.length == 0" style="text-align: center; height: 50px;">
          История презентаций пуста
        </p>
        <PresentationItem
          v-for="(client, index) in presentationsList"
          :key="index"
          :clientInfo="client"
          @deletePresentationItem="deleteItem"
        >
        </PresentationItem>
      </b-tab>


      <b-tab title="Замены">
        <p class="titleMain">История проведенных замен</p>
        <p v-if="replacementList.length == 0" style="text-align: center; height: 50px;">
          История проведенных замен пуста
        </p>
        <ReplacementItem v-for="(client, index) in replacementList" :key="index" :clientInfo="client"></ReplacementItem>
      </b-tab>


      <b-tab title="Отстройки">
        <p class="titleMain">История проведенных отстроек</p>
        <p v-if="manufacturedList.length == 0" style="text-align: center; height: 50px;">
          История отстроек пуста
        </p>
        <ManufactureItem v-for="(client, index) in manufacturedList" :key="index" :clientInfo="client"></ManufactureItem>
      </b-tab>


    </b-tabs>

  </div>
</template>
<script>
import PresentationItem from "@/components/presentation/presentationItem";
import ReplacementItem from "@/components/presentation/replacementItem";
import ManufactureItem from "@/components/presentation/manufactureItem";
export default {
  components: { PresentationItem, ReplacementItem, ManufactureItem },
  data: function () {
    return {
      presentationsList: [],
      replacementList: [],
      manufacturedList: []
    };
  },
  methods: {
    startComponent() {
      // Получить список презентаций
      this.$store.dispatch("GET_PRESENTATION_LIST").then((resp) => {

        if(resp.data.status != "success"){
          this.$makeToast(
            "Упс!",
            "danger",
            "Почему-то с сервера не пришел список презентаций:(",
            5000);
        } else {
          this.presentationsList = resp.data.data.filter(x=> x.completed != 0);
        }

      });

      //Получить список работ по замене
      this.$store.dispatch("GET_REPLACEMENT_LIST").then((resp) => {

        if(resp.data.status != "success"){
          this.$makeToast(
            "Упс!",
            "danger",
            "Почему-то с сервера не пришел список работ по замене:(",
            5000);
        } else {
          this.replacementList = 
          resp.data.items
          .sort(function(a, b) {
              a = new Date(a.dateCreate);
              b = new Date(b.dateCreate);
              return a > b ? -1 : a < b ? 1 : 0;
          });
        }

      });

      //Получить список отстроек
      this.$store.dispatch("GET_MANUFACTURES_LIST").then((resp) => {

        if(resp.data.status != "success"){
          this.$makeToast(
            "Упс!",
            "danger",
            "Почему-то с сервера не пришел список отстроек:(",
            5000);
        } else {
          
          this.manufacturedList = resp.data.data
        }

      });


    },
    deleteItem(){
      this.startComponent()
    }
  },
  created: function () {
     this.startComponent()
  },
};
</script>
<style lang="scss" scoped>
   .client{
        box-shadow: none;
        box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.25);
    }
    
</style>